module.exports = __webpack_public_path__ + "static/media/punkr-logo.c9fc1e6d.svg";